<div class="bo-layout">
    <!-- HEADER BACKOFFICE -->
    <header class="bo-header text-center border-b-2 border-2 bg-white">
        <div class="py-4 px-container flex justify-between lg:gap-0 gap-8 items-center min-h-[135px]">
            <i class="bi bi-list text-4xl font-bold hover:text-accent cursor-pointer" (click)="sidebar=true"></i>

            <img src="../../../assets/images/logo.svg" alt="Logo TeatroColosseo" class="logo w-60 cursor-pointer focus-visible:outline-none lg:block hidden" routerLink="/backoffice">

            <i class="bi bi-box-arrow-right text-4xl font-bold hover:text-accent cursor-pointer" (click)="onLogOut()"></i>
        </div>
    </header>
    <!-- HEADER BACKOFFICE -->

    <div class="bo-main">
        <router-outlet></router-outlet>
    </div>
</div>

<!-- SIDEBAR BACKOFFICE -->
<div class="sidebar-backoffice">

    <p-sidebar #sidebarRef [(visible)]="sidebar" styleClass="lg:w-[30rem] w-full">
        <ng-template pTemplate="headless">
            <div class="flex flex-col h-full">
                <div class="flex items-center justify-between px-6 py-8 shrink-0">
                    <img src="../../../assets/images/logo.svg" alt="Logo TeatroColosseo" class="logo w-40 focus-visible:outline-none">
                    <span>
                        <i class="bi bi-x-lg text-3xl hover:font-bold cursor-pointer" (click)="closeCallback($event)"></i>
                    </span>
                </div>
                <div class="links-backoffice px-6 pt-6 pb-8 flex flex-col justify-between h-full">
                    <ul class="list-none divide-y divide-gray-600/20">

                        <li routerLink="/backoffice/home" routerLinkActive="active" (click)="closeCallback($event)">
                            <a class="link">
                                <span class="font-medium">Home</span>
                            </a>
                        </li>
                        <li routerLink="/backoffice/spettacoli" routerLinkActive="active" (click)="closeCallback($event)">
                            <a class="link">
                                <span class="font-medium">Spettacoli</span>
                            </a>
                        </li>
                        <li routerLink="/backoffice/area-compagnie" routerLinkActive="active" [routerLinkActiveOptions]="{exact: false}" (click)="closeCallback($event)">
                            <a class="link">
                                <span class="font-medium">Area Compagnie</span>
                            </a>
                        </li>
                        <li routerLink="/backoffice/ditte-interventi" routerLinkActive="active" (click)="closeCallback($event)">
                            <a class="link">
                                <span class="font-medium">Fornitori, Manutenzioni e Verifiche</span>
                            </a>
                        </li>
                        <li routerLink="/backoffice/calendario-interventi" routerLinkActive="active" (click)="closeCallback($event)">
                            <a class="link">
                                <span class="font-medium">Calendario interventi</span>
                            </a>
                        </li>
                        <li routerLink="/backoffice/info" routerLinkActive="active" (click)="closeCallback($event)">
                            <a class="link">
                                <span class="font-medium">Info</span>
                            </a>
                        </li>
                        <li routerLink="/backoffice/carnet" routerLinkActive="active" (click)="closeCallback($event)">
                            <a class="link">
                                <span class="font-medium">Carnet</span>
                            </a>
                        </li>
                        <li  routerLink="/backoffice/abbecedario" routerLinkActive="active" (click)="closeCallback($event)">
                            <a class="link">
                                <span class="font-medium">Abbecedario</span>
                            </a>
                        </li>
                        <li routerLink="/backoffice/contatti" routerLinkActive="active" (click)="closeCallback($event)">
                            <a class="link">
                                <span class="font-medium">Contatti</span>
                            </a>
                        </li>
                        <li routerLink="/backoffice/news" routerLinkActive="active" (click)="closeCallback($event)">
                            <a class="link">
                                <span class="font-medium">News</span>
                            </a>
                        </li>
                        <li routerLink="/backoffice/stagione" routerLinkActive="active" (click)="closeCallback($event)">
                            <a class="link">
                                <span class="font-medium">Stagione</span>
                            </a>
                        </li>
                        <li routerLink="/backoffice/amministrazione-trasparente" routerLinkActive="active" (click)="closeCallback($event)">
                            <a class="link">
                                <span class="font-medium">Amministrazione Trasparente</span>
                            </a>
                        </li>
                        <li routerLink="/backoffice/newsletter" routerLinkActive="active" (click)="closeCallback($event)">
                            <a class="link">
                                <span class="font-medium">Newsletter</span>
                            </a>
                        </li>
                        <li routerLink="/backoffice/vouchers" routerLinkActive="active" (click)="closeCallback($event)">
                            <a class="link">
                                <span class="font-medium">Vouchers</span>
                            </a>
                        </li>
                        <!-- <li routerLink="/backoffice/making-teca" routerLinkActive="active" (click)="closeCallback($event)">
                            <a class="link">
                                <span class="font-medium">Making Teca</span>
                            </a>
                        </li>
                        <li routerLink="/backoffice/configurazioni" routerLinkActive="active" (click)="closeCallback($event)" *ngIf="user?.tipo == 'Amministratore'">
                            <a class="link">
                                <span class="font-medium">Configurazioni</span>
                            </a>
                        </li>-->
                        <li routerLink="/backoffice/utenti" routerLinkActive="active" (click)="closeCallback($event)" *ngIf="user?.tipo == 'Amministratore'">
                            <a class="link">
                                <span class="font-medium">Utenti</span>
                            </a>
                        </li>
                    </ul>
                    <ul class="divide-y divide-gray-600/20">
                        <!-- <li>
                            <a class="link" target="_blank" routerLink="/" rel="bookmark">
                                <span class="font-medium">Torna al sito</span>
                            </a>
                        </li> -->
                        <li (click)="password = true">
                            <a class="link">
                                <span class="font-medium">Cambia password</span>
                            </a>
                        </li>
                        <li (click)="openTotp()">
                            <a class="link">
                                <span class="font-medium">Sicurezza 2FA</span>
                            </a>
                        </li>
                        <li (click)="onLogOut()">
                            <a class="link">
                                <span class="font-medium">Esci</span>
                            </a>
                        </li>
                    </ul>


                </div>

            </div>
        </ng-template>
    </p-sidebar>
</div>
<!-- SIDEBAR BACKOFFICE -->


<!-- MODAL PASSWORD -->
<p-dialog
    [visible]="password"
    [style]="{width: 'min(36rem, 94vw)'}"
    [header]="forcePasswordChange ? 'Aggiorna la password' : 'Cambia la tua password'"
    [modal]="true"
    [closable]="!forcePasswordChange"
    [closeOnEscape]="!forcePasswordChange"
    [dismissableMask]="!forcePasswordChange"
    [focusOnShow]="false"
    styleClass="accrediti-dialog"
    (visibleChange)="onPasswordDialogVisible($event)">
    <ng-template pTemplate="content">
        <form [formGroup]="formPassword" class="accrediti-form flex flex-col gap-6" (ngSubmit)="onPassword()">
            <p class="text-sm m-0" style="color: var(--acc-ink-mute)" *ngIf="forcePasswordChange">
                La tua password non rispetta i requisiti di sicurezza. Devi impostarne una nuova per continuare.
            </p>
            <p class="text-sm m-0" style="color: var(--acc-ink-mute)">{{ passwordHint }}</p>
            <div class="fld">
                <label>* Password attuale</label>
                <p-password [toggleMask]="true" formControlName="current_password" placeholder="Password attuale" [feedback]="false" styleClass="w-full" inputStyleClass="w-full" autocomplete="current-password" />
            </div>
            <div class="flex lg:flex-row flex-col gap-4">
                <div class="fld flex-1">
                    <label>* Nuova password</label>
                    <p-password [toggleMask]="true" formControlName="password" placeholder="Nuova password" [feedback]="false" styleClass="w-full" inputStyleClass="w-full" autocomplete="new-password" />
                    <small class="text-red-600 block mt-2 font-medium" *ngIf="formPassword.get('password')?.hasError('strongPassword')">{{ passwordHint }}</small>
                    <small class="text-red-600 block mt-2 font-medium" *ngIf="formPassword.hasError('mismatch') && formPassword.get('confirm_password')?.touched">Le due password non combaciano.</small>
                </div>
                <div class="fld flex-1">
                    <label>* Conferma nuova password</label>
                    <p-password [toggleMask]="true" formControlName="confirm_password" placeholder="Conferma" [feedback]="false" styleClass="w-full" inputStyleClass="w-full" autocomplete="new-password" />
                </div>
            </div>
            <div class="acc-actions">
                <button type="button" class="acc-btn acc-btn-ghost" *ngIf="!forcePasswordChange" (click)="password = false">Annulla</button>
                <button type="button" class="acc-btn acc-btn-ghost" *ngIf="forcePasswordChange" (click)="onLogOut()">Esci</button>
                <button type="submit" class="acc-btn acc-btn-primary" [disabled]="!formPassword.valid">{{ forcePasswordChange ? 'Aggiorna e continua' : 'Modifica' }}</button>
            </div>
        </form>
    </ng-template>
</p-dialog>

<!-- MODAL 2FA -->
<p-dialog [visible]="totpDialog" [style]="{width: 'min(28rem, 94vw)'}" header="Autenticazione a due fattori" [modal]="true" [focusOnShow]="false" styleClass="accrediti-dialog" (visibleChange)="totpDialog = false">
    <ng-template pTemplate="content">
        <div class="accrediti-form flex flex-col gap-4" *ngIf="!totpEnabled && !totpSetup">
            <p class="text-sm m-0" style="color: var(--acc-ink-mute)">Proteggi l’account con un’app autenticatore (Google Authenticator, Authy, …).</p>
            <div class="acc-actions">
                <button type="button" class="acc-btn acc-btn-primary" (click)="startTotpSetup()">Attiva 2FA</button>
            </div>
        </div>

        <div class="accrediti-form flex flex-col gap-4" *ngIf="!totpEnabled && totpSetup">
            <p class="text-sm m-0" style="color: var(--acc-ink-mute)">Scansiona il QR oppure inserisci il codice manuale:</p>
            <img *ngIf="totpSetup.qr" [src]="totpSetup.qr" alt="QR 2FA" class="mx-auto border" width="220" height="220" />
            <code class="text-xs break-all p-2 block" style="background: var(--acc-bg-soft); border: 1px solid var(--acc-line); border-radius: var(--acc-radius)">{{ totpSetup.secret }}</code>
            <form [formGroup]="formTotpEnable" (ngSubmit)="confirmTotpEnable()" class="flex flex-col gap-4">
                <div class="fld">
                    <label>* Codice di verifica</label>
                    <input type="text" pInputText class="w-full" formControlName="code" maxlength="6" inputmode="numeric" autocomplete="one-time-code" placeholder="000000" />
                </div>
                <div class="acc-actions">
                    <button type="submit" class="acc-btn acc-btn-primary" [disabled]="!formTotpEnable.valid">Conferma e attiva</button>
                </div>
            </form>
        </div>

        <div class="accrediti-form flex flex-col gap-4" *ngIf="totpEnabled">
            <p class="text-sm m-0" style="color: var(--acc-ink-mute)">2FA attiva. Per disattivarla servono password e codice OTP.</p>
            <form [formGroup]="formTotpDisable" (ngSubmit)="confirmTotpDisable()" class="flex flex-col gap-4">
                <div class="fld">
                    <label>* Password</label>
                    <p-password [toggleMask]="true" formControlName="password" [feedback]="false" styleClass="w-full" inputStyleClass="w-full" />
                </div>
                <div class="fld">
                    <label>* Codice OTP</label>
                    <input type="text" pInputText class="w-full" formControlName="code" maxlength="6" inputmode="numeric" autocomplete="one-time-code" placeholder="000000" />
                </div>
                <div class="acc-actions">
                    <button type="submit" class="acc-btn acc-btn-danger" [disabled]="!formTotpDisable.valid">Disattiva 2FA</button>
                </div>
            </form>
        </div>
    </ng-template>
</p-dialog>
